"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _StandardProductPageTitle = _interopRequireDefault(require("pricing-pages-unified-ui/components/product-pages/StandardProductPageTitle"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

function _templateObject10() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n            margin-left: 34px;\n            margin-right: 0;\n          "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n          text-align: center;\n        "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n          text-align: right;\n        "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n        padding: 0;\n        width: 100%;\n        text-align: center;\n      "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n        padding-left: 34px;\n        width: 50%;\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      width: 100%;\n      flex-wrap: wrap;\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  &.growth-suite-logos {\n    ", "\n    .growth-suite-logos__logo {\n      white-space: nowrap;\n      div {\n        display: inline-block;\n      }\n      ", "\n      ", "\n      &:nth-child(odd) {\n        ", "\n        ", "\n        .growth-suite-icon {\n          ", "\n        }\n      }\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    margin-top: 0;\n    align-self: center;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    margin-left: 15px;\n    margin-right: 15px;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-size: 26px;\n  line-height: 44px;\n  text-align: center;\n  margin: 0 30px 0;\n  ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledIcon = (0, _styledComponents.default)(_UIIcon.default).withConfig({
  displayName: "GrowthSuiteTitle__StyledIcon",
  componentId: "sc-10l0adi-0"
})(_templateObject(), _responsiveBreakpoints.default.tablet(_templateObject2()), _responsiveBreakpoints.default.tabletPortrait(_templateObject3()));
var StyledFlex = (0, _styledComponents.default)(_UIFlex.default).withConfig({
  displayName: "GrowthSuiteTitle__StyledFlex",
  componentId: "sc-10l0adi-1"
})(_templateObject4(), _responsiveBreakpoints.default.tablet(_templateObject5()), _responsiveBreakpoints.default.tablet(_templateObject6()), _responsiveBreakpoints.default.tabletPortrait(_templateObject7()), _responsiveBreakpoints.default.tablet(_templateObject8()), _responsiveBreakpoints.default.tabletPortrait(_templateObject9()), _responsiveBreakpoints.default.tablet(_templateObject10()));

var GrowthSuiteTitle = function GrowthSuiteTitle() {
  return _react.default.createElement(StyledFlex, {
    className: "growth-suite-logos",
    justify: "between"
  }, _react.default.createElement("div", {
    className: "growth-suite-logos__logo"
  }, _react.default.createElement(_StandardProductPageTitle.default, {
    className: "growth-suite-logos__title",
    hub: 'crm',
    size: "small"
  }), _react.default.createElement(StyledIcon, {
    className: "growth-suite-icon",
    name: "add"
  })), _react.default.createElement("div", {
    className: "growth-suite-logos__logo"
  }, _react.default.createElement(_StandardProductPageTitle.default, {
    hub: 'marketing',
    size: "small"
  }), _react.default.createElement(StyledIcon, {
    className: "growth-suite-icon",
    name: "add"
  })), _react.default.createElement("div", {
    className: "growth-suite-logos__logo"
  }, _react.default.createElement(_StandardProductPageTitle.default, {
    className: "growth-suite-logos__title",
    hub: 'sales',
    size: "small"
  }), _react.default.createElement(StyledIcon, {
    className: "growth-suite-icon",
    name: "add"
  })), _react.default.createElement("div", {
    className: "growth-suite-logos__logo"
  }, _react.default.createElement(_StandardProductPageTitle.default, {
    className: "growth-suite-logos__title",
    hub: 'service',
    size: "small"
  })));
};

var _default = GrowthSuiteTitle;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/growth-suite-page/GrowthSuiteTitle.js
// module id = 854
// module chunks = 5 6